import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TT2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TT2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4V19H22V4H2Z"
        fill="#E31D1C"
      />
      <mask
        id="mask0_1813_983"
        mask-type="luminance"
        maskUnits="userSpaceOnUse"
        x="2"
        y="4"
        width="20"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4V19H22V4H2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1813_983)">
        <path
          d="M20.653 22.6526L20.1101 23.0966L19.6307 22.5848L0.665679 2.33558L0.11736 1.75013L0.738272 1.24232L2.67349 -0.340374L3.21633 -0.784328L3.6957 -0.272497L22.6608 19.9767L23.2091 20.5621L22.5882 21.0699L20.653 22.6526Z"
          fill="#272727"
          stroke="#F7FCFF"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};

export default TT2424Icon;
